import type { FunctionComponent } from 'react';
import { Plans } from '../../constants';
import Banner from '../Banner';
import PlanList from '../PlanList';
import * as styles from '../subscribe-today.module.scss';

type DesktopLayoutProps = {
  selectedPlan: string;
  handlePlanChange: () => void;
};

const DesktopLayout: FunctionComponent<DesktopLayoutProps> = ({
  selectedPlan = Plans.ANNUAL,
  handlePlanChange = () => null,
}) => (
  <div className={styles['desktopLayout']} data-testid="desktop-layout">
    <Banner
      title="Love FabFitFun?"
      subtitle="Keep accessing amazing sales by becoming a FabFitFun member."
    />
    <section className={styles.plans}>
      <PlanList selectedPlan={selectedPlan} handlePlanChange={handlePlanChange} />
    </section>
    <div className={styles['desktopPlaceholder']} />
  </div>
);

export default DesktopLayout;
